import clsx from "clsx";

import { Row } from "@/components/Row";
import { VerificationBadge } from "@/components/VerificationBadge";

export const Avatar = ({
  className,
  initials,
  showVerificationBadge,
}: {
  className?: string;
  initials: string;
  showVerificationBadge?: boolean;
}) => {
  return (
    <div className={clsx("relative", className)}>
      <Row className="h-6 w-6 items-center justify-center rounded-full bg-slate-200">
        <p className="text-[10px] font-medium text-slate-900">{initials}</p>
      </Row>
      {showVerificationBadge && (
        <VerificationBadge className="absolute right-[-6px] top-[15px]" />
      )}
    </div>
  );
};
